import React from 'react'
import { NavLink, useRouteMatch } from 'react-router-dom'
import {
  BackButton,
  BackIcon,
  HamburgerButton,
  HamburgerIcon,
  MobileHeaderLeft,
  SelectorSection,
  WorkspacesDropdownNavbar,
} from './WorkspaceNavbar.styles'

import { WorkspacesDropdown } from '../../containers/WorkspacesDropdown'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'
import { useForTablet } from '@sketch/components'
import { routes, useFlag } from '@sketch/modules-common'

interface WorkspaceNavbarProps {
  workspace: WorkspaceMinimalFragment
  setSidebarLeftOpen?: (state: boolean) => void
}

export const WorkspaceNavbar = (props: WorkspaceNavbarProps) => {
  const { workspace, setSidebarLeftOpen } = props

  // Responsiveness
  const isTabletAndBigger = useForTablet()

  const isBetterNotificationsEnabled = useFlag('better-notifications')
  const isOnUpdates = !!useRouteMatch({
    path: [routes.UPDATES_READ.template(), routes.UPDATES.template()],
  })
  const showBackButton = isBetterNotificationsEnabled && isOnUpdates

  if (isTabletAndBigger) {
    return null
  }

  const isPersonalWorkspace = workspace.type === 'PERSONAL'
  const backRoute = isPersonalWorkspace
    ? routes.ALL_DOCUMENTS.create({})
    : routes.WORKSPACE_SHARES.create({ workspaceId: workspace.identifier })
  const backLabel = isPersonalWorkspace
    ? 'Back to Documents'
    : `Back to ${workspace.name}`

  return (
    <MobileHeaderLeft data-mobile-header-left>
      {showBackButton ? (
        <BackButton as={NavLink} to={backRoute} aria-label={backLabel}>
          <BackIcon />
        </BackButton>
      ) : (
        <WorkspacesDropdownNavbar data-workspace-dropdown-navbar>
          <WorkspacesDropdown workspace={workspace!} size={24} />
        </WorkspacesDropdownNavbar>
      )}
      <SelectorSection>
        <HamburgerButton
          aria-label="Hamburger menu button"
          onClick={() => setSidebarLeftOpen?.(true)}
        >
          <HamburgerIcon />
        </HamburgerButton>
      </SelectorSection>
    </MobileHeaderLeft>
  )
}
